import React from "react";

const accentTop = {
  blue: "border-t-blue-500",
  cyan: "border-t-cyan-500",
  teal: "border-t-teal-500",
  indigo: "border-t-indigo-500",
  violet: "border-t-violet-500",
  magenta: "border-t-fuchsia-500",
};

const iconBg = {
  blue: "bg-blue-100 text-blue-600",
  cyan: "bg-cyan-100 text-cyan-600",
  teal: "bg-teal-100 text-teal-600",
  indigo: "bg-indigo-100 text-indigo-600",
  violet: "bg-violet-100 text-violet-600",
  magenta: "bg-fuchsia-100 text-fuchsia-600",
};

const IndiaCapabilityCard = ({ icon: Icon, title, description, accent }) => {
  return (
    <article
      className={`group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 border-t-4 ${accentTop[accent]} bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-slate-300`}
    >
      <span
        className={`flex h-12 w-12 items-center justify-center rounded-2xl shadow-sm transition-shadow duration-300 group-hover:shadow-[0_0_20px_rgba(37,99,235,0.15)] ${iconBg[accent]}`}
      >
        <Icon className="h-5 w-5" strokeWidth={2} aria-hidden="true" />
      </span>
      <h3 className="mt-5 font-raleway text-lg font-bold text-slate-900">
        {title}
      </h3>
      <p className="mt-2 font-openSans text-sm leading-relaxed text-slate-600">
        {description}
      </p>
    </article>
  );
};

export default IndiaCapabilityCard;
